import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getFormValues, getFormSyncErrors, submit } from 'redux-form';
import { withRouter } from 'react-router';
import { Button, Grid, Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { destroyForm } from 'State/forms/actions';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { Filter } from 'Containers';
import { LoadingPage } from 'Components/loading/LoadingPage';
import {
  setYesNoDialogProps,
  setNotificationDialog,
} from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import {
  DISTRICT_INFORMATION_FORM_NAME,
  DISTRICT_SETTINGS_FORM_NAME,
  PURCHASE_ORDER_INFO_FORM_NAME,
  CONTROL_INFO_MENUS_FORM_NAME,
} from 'Common/FormEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { DirtyWrapper } from 'Components';
import { getTimeZones } from 'State/timeZones/selectors';

import { MenusForm } from './components/MenusForm';
import DistrictInformationForm from './components/DistrictInformationForm';
import DistrictSettingsForm from './components/DistrictSettingsForm';
import PurchaseOrderInfoForm from './components/PurchaseOrderInfoForm';
import { TaxRateSetup } from './components/taxRates/TaxRateSetup';
import HouseholdForm from './components/HouseHoldForm';
import {
  districtInfoInitialValues,
  districtSettingsInitialValues,
  districtInfoSubmitValues,
  districtSettingsSubmitValues,
  purchaseOrderInfoInitialValues,
  purchaseOrderInfoSubmitValues,
  menusSubmitValues,
  menusFormInitialValues,
  tabEnum,
} from './helpers/ControlInfoObjects';
import {
  UPDATE_SUCCESS_NOTIFICATION,
  UPDATE_FAILED_NOTIFICATION,
  PREVIEW_SUCCESS_NOTIFICATION,
  PREVIEW_FAILED_NOTIFICATION,
} from './helpers/Constants';
import { getTimeZonesAction } from '../../state/timeZones/actions';
import * as actions from './state/districtInfo/actions';
import { getHACCP, getHACCPType } from './state/haccp/actions';
import { getRecipeGroups } from './state/recipeGroup/actions';
import {
  getIngredientGroups,
  getIngredientSources,
} from './state/ingredientGroup/actions';
import {
  setCNUpdateLoading,
  setCNPreviewLoading,
  getCNVersionInformation,
  setPreviewEnqueuedSuccessfull,
} from './state/CNVersionInformation/actions';
import * as DistrictInfoSelector from './state/districtInfo/selectors';
import * as CNVersionSelectors from './state/CNVersionInformation/selectors';

class ControlInformationContainer extends Component {
  static propTypes = {
    getTimeZonesAction: PropTypes.func.isRequired,
    destroyForm: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    getHACCP: PropTypes.func.isRequired,
    getHACCPType: PropTypes.func.isRequired,
    getRecipeGroups: PropTypes.func.isRequired,
    getIngredientGroups: PropTypes.func.isRequired,
    getIngredientSources: PropTypes.func.isRequired,
    getControlDistrictInfo: PropTypes.func.isRequired,
    getMobileInventoryLicenseCount: PropTypes.func.isRequired,
    writeMobileInventoryData: PropTypes.func.isRequired,
    setYesNoDialogProps: PropTypes.func.isRequired,
    setNotificationDialog: PropTypes.func.isRequired,
    setEnableMobileInventory: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    fetchingMobileInventoryLicense: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    districtFormValues: PropTypes.object,
    menusFormValues: PropTypes.object,
    districtSettingsValues: PropTypes.object,
    purchaseOrderInfoValues: PropTypes.object,
    districtInfo: PropTypes.object,
    fetchError: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    submitError: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    districtInfoErrors: PropTypes.object.isRequired,
    districtSettingsErrors: PropTypes.object.isRequired,
    timeZones: PropTypes.array,
    invAppEnabled: PropTypes.bool,
    fetchMobileInventoryLicenseError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    mobileSyncResponseMsg: PropTypes.string,
    fetchMobileSyncError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    districtFormValues: {},
    menusFormValues: {},
    districtSettingsValues: {},
    purchaseOrderInfoValues: {},
    districtInfo: {},
    fetchError: null,
    submitError: null,
    invAppEnabled: false,
    timeZones: [],
    fetchMobileInventoryLicenseError: null,
    mobileSyncResponseMsg: '',
    fetchMobileSyncError: null,
  };

  state = {
    headerInfo: tabEnum.Info,
  };

  headerRowButtons = [
    { title: 'District Information', value: tabEnum.Info },
    { title: 'District Settings', value: tabEnum.Settings },
    { title: 'Menus', value: tabEnum.Menus },
    { title: 'Purchase Order', value: tabEnum.PurchaseOrder },
    { title: 'Household Categorical Case Type', value: tabEnum.CaseTypes },
    { title: 'Tax Rates', value: tabEnum.TaxRates },
  ];

  componentDidMount() {
    const {
      getTimeZonesAction,
      getHACCP,
      getHACCPType,
      getRecipeGroups,
      getIngredientGroups,
      getIngredientSources,
      getControlDistrictInfo,
      getMobileInventoryLicenseCount,
      getCNVersionInformation,
    } = this.props;

    getControlDistrictInfo();
    getTimeZonesAction();
    getHACCP();
    getHACCPType();
    getRecipeGroups();
    getIngredientGroups();
    getIngredientSources();
    getMobileInventoryLicenseCount();
    getCNVersionInformation(true);
  }

  componentDidUpdate(prevProps) {
    const {
      clearControlInfoErrorSuccess,
      notifications,
      cnUpdateLoading,
      cnPreviewLoading,
      setCNUpdateLoading,
      getCNVersionInformation,
      setCNPreviewLoading,
      setPreviewEnqueuedSuccessfull,
    } = this.props;

    if (
      errorToast(this.props, prevProps, 'fetchError') ||
      errorToast(this.props, prevProps, 'fetchMobileInventoryLicenseError') ||
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'fetchMobileSyncError') ||
      errorToast(this.props, prevProps, 'fetchCNVersionInformationError') ||
      errorToast(this.props, prevProps, 'cnVersionUpdateEnqueueError')
    ) {
      clearControlInfoErrorSuccess();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Control Information saved successfully',
        true
      );
      clearControlInfoErrorSuccess();
    } else if (
      this.props.mobileSyncResponseMsg &&
      !prevProps.mobileSyncResponseMsg
    ) {
      createToast(
        toastType.success,
        'Success',
        this.props.mobileSyncResponseMsg,
        true
      );
      clearControlInfoErrorSuccess();
    } else if (
      this.props.cnVersionUpdateEnqueueSuccess &&
      !prevProps.cnVersionUpdateEnqueueSuccess
    ) {
      createToast(
        toastType.info,
        'Success',
        'CN Update Has Been Enqueued',
        true
      );
    } else if (
      this.props.cnPreviewEnqueuedSuccessfully &&
      !prevProps.cnPreviewEnqueuedSuccessfully
    ) {
      createToast(
        toastType.info,
        'Success',
        'CN Preview Has Been Enqueued',
        true
      );
    }

    const firstTitle = _.get(notifications, '[0].Title');
    if (
      cnUpdateLoading &&
      _.get(notifications, 'length', 0) >
        _.get(prevProps, 'notifications.length', 0) &&
      (firstTitle === UPDATE_SUCCESS_NOTIFICATION ||
        firstTitle === UPDATE_FAILED_NOTIFICATION)
    ) {
      setCNUpdateLoading(false);
      getCNVersionInformation(false);
    }
    if (
      cnPreviewLoading &&
      _.get(notifications, 'length', 0) >
        _.get(prevProps, 'notifications.length', 0) &&
      (firstTitle === PREVIEW_SUCCESS_NOTIFICATION ||
        firstTitle === PREVIEW_FAILED_NOTIFICATION)
    ) {
      setCNPreviewLoading(false);
      setPreviewEnqueuedSuccessfull(false);
      getCNVersionInformation(false);
    }
  }

  componentWillUnmount() {
    this.props.destroyForm(DISTRICT_SETTINGS_FORM_NAME);
    this.props.destroyForm(DISTRICT_INFORMATION_FORM_NAME);
  }

  handleDistrictInfoSubmit = (values) => {
    return districtInfoSubmitValues(values);
  };

  handleDistrictSettingsSubmit = (values) => {
    return districtSettingsSubmitValues(values);
  };

  handlePurchaseOrderInfoSubmit = (values) => {
    return purchaseOrderInfoSubmitValues(values);
  };

  handleMenusSubmit = (values) => {
    return menusSubmitValues(values);
  };

  saveDistrictDetails = async () => {
    const {
      districtFormValues,
      districtSettingsValues,
      districtInfo,
      saveControlDistrictInfo,
      districtInfoErrors,
      districtSettingsErrors,
      purchaseOrderInfoValues,
      menusFormValues,
    } = this.props;

    if (Object.keys(districtInfoErrors).length > 0) {
      this.setState({ headerInfo: tabEnum.Info });
    } else if (Object.keys(districtSettingsErrors).length > 0) {
      this.setState({ headerInfo: tabEnum.Settings });
    } else {
      //ok to save
      const saveObject = {
        ...districtInfo,
        ...(districtFormValues
          ? this.handleDistrictInfoSubmit(districtFormValues)
          : {}),
        ...(districtSettingsValues
          ? this.handleDistrictSettingsSubmit(districtSettingsValues)
          : {}),
        ...(purchaseOrderInfoValues
          ? this.handlePurchaseOrderInfoSubmit(purchaseOrderInfoValues)
          : {}),
        ...(menusFormValues ? this.handleMenusSubmit(menusFormValues) : {}),
      };
      saveControlDistrictInfo(saveObject);
    }
  };

  getMainProps = () => {
    const rightButtons = [];

    const { isReadOnly, submitting } = this.props;

    rightButtons.push({
      content: 'Save',
      onClick: this.saveDistrictDetails,
      disabled: submitting || isReadOnly,
      loading: submitting,
    });

    return {
      toolbox: {
        rightButtons,
        shown: true,
      },
    };
  };

  handleMobileSync = () => {
    const { setNotificationDialog, writeMobileInventoryData } = this.props;
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.CONTROL_INFORMATION_DISTRICT_SETTING_MOBILE_SYNC_INFO,
      actionsToDispatchOnOk: [() => writeMobileInventoryData()],
    });
  };

  handleEnableMobileInventoryCheckbox = (event, value) => {
    const {
      invAppEnabled,
      setYesNoDialogProps,
      setEnableMobileInventory,
    } = this.props;
    if (invAppEnabled && !value) {
      setYesNoDialogProps({
        showDialog: true,
        title: 'Inventory',
        question:
          'Disabling feature may cause loss of Mobile Inventory data. Are you sure you want to continue?',
        yesCallback: () => {},
        noCallback: () => setEnableMobileInventory(),
      });
    }
  };

  render() {
    const {
      isReadOnly,
      districtInfo,
      fetching,
      timeZones,
      fetchingMobileInventoryLicense,
      cnVersionInformation,
      fetchingCNVersionInformation,
    } = this.props;

    const { headerInfo } = this.state;

    return fetching ||
      fetchingMobileInventoryLicense ||
      fetchingCNVersionInformation ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Control Information'} newRow={true}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={14}>
                <Menu compact widths={this.headerRowButtons.length}>
                  {this.headerRowButtons.map((button) => (
                    <Menu.Item
                      key={button.title}
                      name={button.title}
                      active={headerInfo === button.value}
                      onClick={() =>
                        this.setState({
                          headerInfo: button.value,
                        })
                      }
                    />
                  ))}
                </Menu>
              </Grid.Column>
              {headerInfo === tabEnum.CaseTypes && (
                <Grid.Column width={2} floated="right" textAlign="right">
                  <Button
                    content="Add Case"
                    onClick={() => this.Household.showAddModal()}
                    disabled={isReadOnly}
                  />
                </Grid.Column>
              )}
              {headerInfo === tabEnum.TaxRates && (
                <Grid.Column width={2} floated="right" textAlign="right">
                  <Button
                    content="Add Tax Rate"
                    onClick={() => this.TaxRateSetup.openCreateModal()}
                    disabled={isReadOnly}
                  />
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Filter>
        {!_.isEmpty(districtInfo) && (
          <DistrictInformationForm
            onSubmit={this.handleDistrictInfoSubmit}
            mainProps={this.getMainProps()}
            initialValues={districtInfoInitialValues(districtInfo)}
            hide={headerInfo !== tabEnum.Info}
          />
        )}
        {!_.isEmpty(districtInfo) && (
          <DistrictSettingsForm
            onSubmit={this.handleDistrictSettingsSubmit}
            mainProps={this.getMainProps()}
            generateServingNum={districtInfo.GenerateServingNum}
            initialValues={districtSettingsInitialValues(districtInfo)}
            timeZones={timeZones}
            handleMobileSync={this.handleMobileSync}
            handleEnableMobileInventoryCheckbox={
              this.handleEnableMobileInventoryCheckbox
            }
            hide={headerInfo !== tabEnum.Settings}
          />
        )}
        {!_.isEmpty(districtInfo) && (
          <PurchaseOrderInfoForm
            onSubmit={this.handlePurchaseOrderInfoSubmit}
            mainProps={this.getMainProps()}
            initialValues={purchaseOrderInfoInitialValues(districtInfo)}
            hide={headerInfo !== tabEnum.PurchaseOrder}
          />
        )}
        <HouseholdForm
          onRef={(ref) => (this.Household = ref)}
          mainProps={this.getMainProps()}
          isReadOnly={isReadOnly}
          hide={headerInfo !== tabEnum.CaseTypes}
        />
        {headerInfo === tabEnum.TaxRates && (
          <TaxRateSetup onRef={(ref) => (this.TaxRateSetup = ref)} />
        )}
        {headerInfo === tabEnum.Menus && (
          <DirtyWrapper>
            {(showDirtyConfirm) => {
              return (
                <MenusForm
                  onSubmit={this.handleMenusSubmit}
                  mainProps={this.getMainProps()}
                  initialValues={menusFormInitialValues(districtInfo)}
                  isReadOnly={isReadOnly}
                  showDirtyConfirm={showDirtyConfirm}
                  cnVersionInformation={cnVersionInformation}
                />
              );
            }}
          </DirtyWrapper>
        )}
      </Fragment>
    );
  }
}

const districtFormValuesSelector = getFormValues(
  DISTRICT_INFORMATION_FORM_NAME
);
const districtSettingsSelector = getFormValues(DISTRICT_SETTINGS_FORM_NAME);
const purchaseOrderSelector = getFormValues(PURCHASE_ORDER_INFO_FORM_NAME);
const menusFormSelector = getFormValues(CONTROL_INFO_MENUS_FORM_NAME);
const districtInfoErrorsSelector = getFormSyncErrors(
  DISTRICT_INFORMATION_FORM_NAME
);
const districtSettingsErrorsSelector = getFormSyncErrors(
  DISTRICT_SETTINGS_FORM_NAME
);

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty()(state));
  return {
    districtInfo: DistrictInfoSelector.getData(state),
    fetching: DistrictInfoSelector.getFetching(state),
    fetchError: DistrictInfoSelector.getFetchError(state),
    submitError: DistrictInfoSelector.getSubmitError(state),
    submitting: DistrictInfoSelector.getSubmitting(state),
    submitted: DistrictInfoSelector.getSubmitted(state),
    fetchingMobileInventoryLicense: DistrictInfoSelector.getFetchingMobileInventoryLicense(
      state
    ),
    fetchMobileInventoryLicenseError: DistrictInfoSelector.getFetchMobileInventoryLicenseError(
      state
    ),
    mobileSyncResponseMsg: DistrictInfoSelector.getMobileSyncResponseMsg(state),
    fetchMobileSyncError: DistrictInfoSelector.getFetchMobileSyncError(state),
    invAppEnabled: DistrictInfoSelector.getInvAppEnabled(state),

    districtFormValues: districtFormValuesSelector(state),
    districtSettingsValues: districtSettingsSelector(state),
    purchaseOrderInfoValues: purchaseOrderSelector(state),
    menusFormValues: menusFormSelector(state),
    districtInfoErrors: districtInfoErrorsSelector(state),
    districtSettingsErrors: districtSettingsErrorsSelector(state),
    timeZones: getTimeZones(state),
    cnVersionInformation: CNVersionSelectors.getCNVersionInformation(state),
    fetchCNVersionInformationError: CNVersionSelectors.getCNVersionInformationFetchError(
      state
    ),
    fetchingCNVersionInformation: CNVersionSelectors.getCNVersionInformationFetchLoading(
      state
    ),
    cnVersionUpdateEnqueueSuccess: CNVersionSelectors.getCNVersionUpdateEnqueueSuccess(
      state
    ),
    cnVersionUpdateEnqueueError: CNVersionSelectors.getCNVersionUpdateEnqueueError(
      state
    ),
    notifications: CNVersionSelectors.getNotifications(state),
    cnUpdateLoading: CNVersionSelectors.getCNVersionUpdateLoading(state),
    cnPreviewLoading: CNVersionSelectors.getCNPreviewLoading(state),
    cnPreviewEnqueuedSuccessfully: CNVersionSelectors.getCNPreviewEnqueuedSuccessfully(
      state
    ),
  };
};

const mapDispatchToProps = {
  ...actions,
  getTimeZonesAction,
  destroyForm,
  submit,
  getHACCP,
  getHACCPType,
  getRecipeGroups,
  getIngredientGroups,
  getIngredientSources,
  setYesNoDialogProps,
  setNotificationDialog,
  getCNVersionInformation,
  setCNUpdateLoading,
  setCNPreviewLoading,
  setPreviewEnqueuedSuccessfull,
};

export const ControlInformation = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ControlInformationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/ControlInformation.js